import { IInsurer, IPartner } from '@inshuwa-client/models';
import { sessionStore } from './session-store';

export const isPiczInsurer = (input?: string): boolean => {
  if (input) {
    return input === 'Professional Insurance Corporation Zambia';
  }
  const name = localStorage.getItem('insurer');
  if (!name) {
    return false;
  }
  const parsedName = JSON.parse(name) as IInsurer;
  return parsedName.name === 'Professional Insurance Corporation Zambia';
};

export const isAirtel = (input?: string): boolean => {
  if (input) {
    return input === 'Airtel';
  }
  const name = sessionStore.getItem('partner');
  if (!name) {
    return false;
  }
  const parsedName = JSON.parse(name) as IPartner;
  return parsedName.name.trim() === 'Airtel';
};

export const isMtn = (input?: string): boolean => {
  const name =
    input ??
    (() => {
      const stored = sessionStore.getItem('partner');
      return stored ? (JSON.parse(stored) as IPartner).name : '';
    })();
  return name.toLowerCase().includes('mtn');
};

export const isMinet = (portalName?: string | null): boolean => {
  return portalName === 'Minet';
};

export const isTravelOrLifeProduct = (classOfBusinessName: string): boolean => {
  if (!classOfBusinessName) {
    return false;
  }

  return ['travel', 'life'].includes(classOfBusinessName.toLowerCase());
};

export const piczRegistrationTerms = ` <ol>
  <li>1. You must be 18+.</li>
  <li>2. Your personal data will be used for policy administration and protected under applicable data laws.</li>
  <li>3. Standard Chartered Bank Zambia is not responsible for insurance terms, performance, or claims.</li>
  <li>3. PICZ may amend these terms with prior notification via SMS.</li>
  <li>By proceeding, you agree to review the full Ts &amp; Cs at <a href="https://www.picz.co.zm/terms">https://www.picz.co.zm/terms</a>.</li>
</ol> `;

export const termsAndConditions = `
<ol>
  <li>1. Your policy is valid only if you complete a digital inspection via the MyPICZ Inspection App within 24 hours. A link will be sent via SMS.</li>
  <li>2. Any claims for loss or damage to the insured property before the digital inspection is completed will not be admissible.</li>
</ol>
`;
